import { RemoteSourceRow } from 'components/tables/data/remote-source/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the remote source URL.
 */
export default function UrlColumn({ data: { url } }: { data: RemoteSourceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3} style={{ wordBreak: 'break-all' }}>
      {url}
    </P2Regular>
  );
}
